export default __webpack_public_path__ + "static/media/yeuxCoulent.18dd248f.png";